import axios from "@axios"

export default function dateUtils() {

  







    /**
     * Formatear una fecha en formato "y-m-d" a formato español
     * @param {Date} date 
     * @returns String
     */


    const formatDate = function(date) {
        const dateObject = new Date(date);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month =  String(dateObject.getMonth() + 1).padStart(2, '0'); 
        const year = dateObject.getFullYear();

        return `${day}-${month}-${year}`;
    }

    return {
    
        formatDate
    }

}